import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { utcToLocalFormat } from "app/shared/pipes/utc-to-local.pipe";
import { DishesService } from 'app/services/dishes.service';
import { PageEvent } from '@angular/material/paginator';

@UntilDestroy()
@Component({
  selector: 'app-menu-event-modal',
  templateUrl: './menu-event-modal.component.html',
  styleUrls: ['./menu-event-modal.component.scss']
})
export class MenuEventModalComponent implements AfterViewInit  {
  dataSource = new MatTableDataSource([]);
  columnsToDisplay = ['userEmail', 'entity', 'menuActionType', 'oldData', 'newData', 'createdAt'];
  dateFormat: string = utcToLocalFormat;
  menuSectionId: string;
  positionId: string;

  pageIndex: number = 0;
  pageSize: number = 100;
  totalItems: number;

  async ngAfterViewInit() {
    await this.loadDataAsync();
  }

  constructor(
    private dishesService: DishesService,
    private translate: TranslateService,
    public dialogRef: MatDialogRef<MenuEventModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.menuSectionId = this.data.menuSectionId;
    this.positionId = this.data.positionId;
  }

  async loadDataAsync() {
    const menuEventsResponse = await this.dishesService.getMenuEventsAsync({
      menuSectionId: this.menuSectionId,
      entityId: this.positionId,
      pageIndex: this.pageIndex + 1,
      pageSize: this.pageSize,
    });

    if (!menuEventsResponse.success){
      this.dataSource = new MatTableDataSource([]);
      return;
    }

    this.totalItems = menuEventsResponse.data.totalItems;
    this.dataSource = new MatTableDataSource(menuEventsResponse.data.items);
  }

  async handlePageEventAsync(pageEvent: PageEvent) {
    this.pageIndex = this.pageSize != pageEvent.pageSize? 0: pageEvent.pageIndex;
    this.pageSize = pageEvent.pageSize;

    const menuEventsResponse = await this.dishesService.getMenuEventsAsync({
      menuSectionId: this.menuSectionId,
      entityId: this.positionId,
      pageIndex: this.pageIndex + 1,
      pageSize: this.pageSize,
    });

    this.totalItems = menuEventsResponse.data.totalItems;
    this.dataSource = new MatTableDataSource(menuEventsResponse.data.items);
  }

  getColumnHeader(columnHeaderValue: string): string {
    switch (columnHeaderValue) {
      case 'userEmail':
        return this.translate.instant('MENU.EVENT.USER');
      case 'entity':
        return this.translate.instant('MENU.EVENT.ENTITY');
      case 'menuActionType':
        return this.translate.instant('MENU.EVENT.ACTION_TYPE');
      case 'oldData':
        return this.translate.instant('MENU.EVENT.OLD_DATA');
      case 'newData':
        return this.translate.instant('MENU.EVENT.NEW_DATA');
      case 'createdAt':
        return this.translate.instant('MENU.EVENT.CREATED_AT');
      default:
        return '';
    }
  }
}
